import cloneDeep from "lodash/cloneDeep";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { debounce, orderBy } from "lodash";
import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import ValidationDialog from "@/components/Common/ValidationDialog/ValidationDialog.vue";
import KisList from "@/components/KIS/KisList/KisList.vue";
import KisTaskEditDialog from "@/components/KIS/KisTaskEditDialog/KisTaskEditDialog.vue";
import { update } from "lodash/object";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

const defaultItem = {
  name: "",
  description: "",
  leika_id: "",
  files: [],
  links: [],
  related_tasks: [],
  teaser: "",
  showInList: true,
  active: true
};

export default {
  name: "KisTasks",
  components: {
    KisTaskEditDialog,
    KisList,
    ValidationDialog,
    TreeViewSelection
  },
  data: () => ({
    loading: false,
    editedItem: {},
    editDialog: false,
    filter: { name: "", limit: 10 },
    headers: [
      { text: "Name", value: "name" },
      { text: "Zuletzt geändert am", value: "updatedAt" },
      { text: "Aktiv", value: "active" },
      { text: "Aktionen", sortable: false, value: "actions" }
    ]
  }),
  async mounted() {
    this.loading = true;
    const itemsPerPage = this.itemsPerPage;
    if (itemsPerPage && !isNaN(itemsPerPage)) {
      this.filter.limit = itemsPerPage;
      this.filter.itemsPerPage = itemsPerPage;
      this.itemsPerPage = itemsPerPage;
    }
    await this.$store.dispatch("getTasks", this.filter);
    await this.$store.dispatch("getDepartments");
    await this.$store.dispatch("getSubjectAreas");
    await this.getAllPersons();
    await this.$store.dispatch("getAllUsers");
    this.loading = false;
  },
  methods: {
    update,
    editItem(item) {
      this.editDialog = true;
      this.editedItem = cloneDeep(item);
      this.$refs.taskEditDialog.fillData(this);
    },
    async getAllPersons() {
      const limit = 100;

      await this.$store.dispatch("getPersons", {
        limit,
        getAll: true
      });
    },
    addNewTask() {
      this.editedItem = cloneDeep(defaultItem);
      this.editDialog = true;
      this.$refs.taskEditDialog.fillData(this);
    },
    copyItem(item) {
      this.editedItem = cloneDeep(item);
      delete this.editedItem?._id;
      this.editDialog = true;
      this.$refs.taskEditDialog.fillData(this);
    },
    setTask(item) {
      this.editedItem = item;
    },
    closeDialog() {
      this.editedItem = cloneDeep(defaultItem);
      this.editDialog = false;
      this.$refs.taskEditDialog.fillData(this);
    },
    async getTasks(filter) {
      await this.$store.dispatch("getTasks", filter);
    },
    setFilterPage(page) {
      this.filter.page = page;
    },
    setFilterLimit(limit) {
      this.filter.limit = limit;
      this.filter.itemsPerPage = limit;
      localStorage.setItem("itemsPerPage", limit);
    },
    async updateTask(task) {
      try {
        const headers = getTokenHeader();
        if (!this.editedItem.principal_id)
          this.editedItem.principal_id = this.currentPrincipal;
        const response = await axios.put(
          `${env.kis_api_client_url}task/${task._id}`,
          task,
          {
            params: {
              principal_id: task.principal_id
            },
            headers
          }
        );
        if (response.status === 200) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
          await this.$store.dispatch("getTasks", this.filter);
        } else {
          console.error(response);
          await this.$store.dispatch(
            "createError",
            "Es ist ein Fehler aufgetreten!"
          );
        }
        this.$refs.taskEditDialog.fillData(this);
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    },
    async deleteTask(task) {
      try {
        const confirm = await this.$confirm(
          "Möchten Sie diesen Geschäftsbereich wirklich löschen?",
          confirmWarningConfig
        );
        if (confirm) {
          const headers = getTokenHeader();
          if (!this.editedItem.principal_id)
            this.editedItem.principal_id = this.currentPrincipal;
          const response = await axios.delete(
            `${env.kis_api_client_url}task/${task._id}`,
            {
              params: {
                principal_id: task.principal_id
              },
              headers
            }
          );
          if (response.status === 200) {
            await this.$store.dispatch(
              "createSuccess",
              "Erfolgreich gelöscht!"
            );
            this.setTask(response.data);
            await this.$store.dispatch("getTasks", this.filter);
          } else {
            console.error(response);
            await this.$store.dispatch(
              "createError",
              "Es ist ein Fehler aufgetreten!"
            );
          }
        }
        this.$refs.taskEditDialog.fillData(this);
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    },
    applySearchText: debounce(async function() {
      if (this.filter.name.length >= 3 || !this.filter.name.length)
        await this.$store.dispatch("getTasks", this.filter);
    }, 500)
  },
  computed: {
    tasks() {
      return this.$store.state.tasks;
    },
    departments() {
      return this.$store.state.departments?.map(
        area =>
          (area = {
            title: area.name,
            ...area
          })
      );
    },
    persons() {
      return orderBy(this.$store.state.persons, "firstName");
    },
    subjectAreas() {
      return this.$store.state.subjectAreas?.map(
        area =>
          (area = {
            title: area.name,
            ...area
          })
      );
    },
    personCount() {
      return this.$store.state.personCount;
    },
    taskCount() {
      return this.$store.state.taskCount;
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    }
  }
};
